var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-modal-wrapper"},_vm._l((_vm.activeModals),function(modal){return _c('Modal',{key:modal.modal,attrs:{"modal":modal}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }